import React from "react"
import styled from "styled-components"
import {
  FacebookLogo,
  HatenaLogo,
  PocketLogo,
  XLogo,
  LINELogo,
} from "../images/images"
import { globalHistory } from "@reach/router"

const SHARE_PLATFORMS: {
  link?: ((_text?: string | undefined) => string) | undefined
  click?: ((_text?: string | undefined) => void) | undefined
  label: string
  background: string
  borderColor: string
  icon?: any
}[] = [
  {
    label: "X",
    background: "#fff",
    borderColor: "#000",
    icon: XLogo,
    link: (_text?: string): string => {
      const link = encodeURIComponent(globalHistory.location.href)
      return "https://twitter.com/intent/tweet?text=" + link
    },
  },
  {
    label: "Facebook",
    background: "#fff",
    borderColor: "#305097",
    icon: FacebookLogo,
    ...(typeof window !== "undefined" && {
      click: (_text?: string) => {
        const link = encodeURIComponent(globalHistory.location.href)
        window.open(
          "https://www.facebook.com/sharer/sharer.php?u=" + link,
          "facebook-share-dialog",
          "width=626,height=436"
        )
      },
    }),
  },
  {
    label: "はてブ",
    background: "#fff",
    borderColor: "#5D8AC1",
    icon: HatenaLogo,
    ...(typeof window !== "undefined" && {
      link: (_text?: string) => {
        const link = encodeURIComponent(globalHistory.location.href)
        return "https://b.hatena.ne.jp/entry/" + link
      },
    }),
  },
  {
    label: "Pocket",
    background: "#fff",
    borderColor: "#F03E51",
    icon: PocketLogo,
    ...(typeof window !== "undefined" && {
      click: (_text?: string) => {
        const link = globalHistory.location.href
        window.open("mailto:add@getpocket.com?body=" + link, "_blank")
      },
    }),
  },
  {
    label: "Line",
    background: "#fff",
    borderColor: "#6CC655",
    icon: LINELogo,
    ...(typeof window !== "undefined" && {
      link: (_text?: string) => {
        const link = encodeURIComponent(globalHistory.location.href)
        return `https://social-plugins.line.me/lineit/share?url=${link}}`
      },
    }),
  },
]

export const ShareGrid: React.FC = () => {
  return (
    <ShareGridDiv elements={SHARE_PLATFORMS.length}>
      {SHARE_PLATFORMS.map(share => (
        <ShareItem
          {...(share.link && { href: share.link(), target: "_blank" })}
          onClick={() => {
            if (share.click) {
              share.click()
            }
          }}
          background={share.background}
          borderColor={share.borderColor}
          key={share.label}
        >
          {share.icon && <img src={share.icon} alt={share.icon || "icon"} />}
        </ShareItem>
      ))}
    </ShareGridDiv>
  )
}

const ShareGridDiv = styled.div<{ elements: number }>`
  margin-bottom: 40px;
  display: grid;
  grid-template-columns: ${({ elements }) => `repeat(${elements}, 1fr)`};
  gap: 16px;

  /* SP style */
  @media screen and (max-width: 767px) {
    gap: 8px;
  }
`

const ShareItem = styled.a<{ background: string; borderColor: string }>`
  cursor: pointer;
  width: 100%;
  display: flex;
  background: ${({ background }) => background};
  height: 48px;
  align-items: center;
  border: 2px solid ${({ borderColor }) => borderColor};
  border-radius: 24px;
  color: white;
  justify-content: center;
  text-decoration: none;

  /* SP style */
  @media screen and (max-width: 767px) {
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }

  img {
    max-width: 24px;
  }
`
